import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import '../../../../components/Display/Data.scss';
import Section from '../../../../components/Display/Section';
import ImageItem from '../../common/image/ImageItem';

function CircumstanceDetail({ circumstance, handleUpdateCircumstance, handleDelete }) {
  const updateCircumstanceActions = [
    {
      onClick: handleUpdateCircumstance,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (circumstance) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette circonstance ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(circumstance)
    });
  };

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updateCircumstanceActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={circumstance.title} large />
          <Data key="label" label={'Légende'} value={circumstance.description} large />
        </div>
      </Section>
      <Section label="Images">
        {circumstance.images.map((image) => (
          <ImageItem key={image.id} image={image} className="w-96" />
        ))}
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={'Supprimer la circonstance'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(circumstance)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default CircumstanceDetail;
